// ── ISO/IEC 27001:2022 MAIN CLAUSES (4–10) ─────────────────────────────────────
export const ISO_CLAUSES = {
  '4.1':   { es: 'Comprensión de la organización y de su contexto',
             en: 'Understanding the organization and its context' },
  '4.2':   { es: 'Necesidades y expectativas de las partes interesadas',
             en: 'Understanding the needs and expectations of interested parties' },
  '4.3':   { es: 'Determinación del alcance del SGSI',
             en: 'Determining the scope of the ISMS' },
  '4.4':   { es: 'Sistema de gestión de seguridad de la información',
             en: 'Information security management system' },
  '5.1':   { es: 'Liderazgo y compromiso',
             en: 'Leadership and commitment' },
  '5.2':   { es: 'Política',
             en: 'Policy' },
  '5.3':   { es: 'Roles, responsabilidades y autoridades',
             en: 'Organizational roles, responsibilities and authorities' },
  '6.1':   { es: 'Acciones para abordar riesgos y oportunidades',
             en: 'Actions to address risks and opportunities' },
  '6.1.1': { es: 'Generalidades', en: 'General' },
  '6.1.2': { es: 'Apreciación de riesgos de seguridad de la información',
             en: 'Information security risk assessment' },
  '6.1.3': { es: 'Tratamiento de riesgos de seguridad de la información',
             en: 'Information security risk treatment' },
  '6.2':   { es: 'Objetivos de seguridad de la información y planificación',
             en: 'Information security objectives and planning to achieve them' },
  '6.3':   { es: 'Planificación de cambios', en: 'Planning of changes' },
  '7.1':   { es: 'Recursos', en: 'Resources' },
  '7.2':   { es: 'Competencia', en: 'Competence' },
  '7.3':   { es: 'Concienciación', en: 'Awareness' },
  '7.4':   { es: 'Comunicación', en: 'Communication' },
  '7.5':   { es: 'Información documentada', en: 'Documented information' },
  '7.5.1': { es: 'Generalidades', en: 'General' },
  '7.5.2': { es: 'Creación y actualización', en: 'Creating and updating' },
  '7.5.3': { es: 'Control de la información documentada',
             en: 'Control of documented information' },
  '8.1':   { es: 'Planificación y control operacional',
             en: 'Operational planning and control' },
  '8.2':   { es: 'Apreciación de riesgos de seguridad de la información',
             en: 'Information security risk assessment' },
  '8.3':   { es: 'Tratamiento de riesgos de seguridad de la información',
             en: 'Information security risk treatment' },
  '9.1':   { es: 'Seguimiento, medición, análisis y evaluación',
             en: 'Monitoring, measurement, analysis and evaluation' },
  '9.2':   { es: 'Auditoría interna', en: 'Internal audit' },
  '9.2.1': { es: 'Generalidades', en: 'General' },
  '9.2.2': { es: 'Programa de auditoría interna',
             en: 'Internal audit program' },
  '9.3':   { es: 'Revisión por la dirección', en: 'Management review' },
  '9.3.1': { es: 'Generalidades', en: 'General' },
  '9.3.2': { es: 'Entradas de la revisión por la dirección',
             en: 'Management review inputs' },
  '9.3.3': { es: 'Resultados de la revisión por la dirección',
             en: 'Management review results' },
  '10.1':  { es: 'Mejora continua', en: 'Continual improvement' },
  '10.2':  { es: 'No conformidad y acción correctiva',
             en: 'Nonconformity and corrective action' },
};
